module.exports = __webpack_public_path__ + "assets/img/goods2.27211c31.svg";